module.exports = __webpack_public_path__ + "media/images/soar/site/woman_01@2x-22108e7a8a6aaa9b42d5b8bca5afd935.png";